﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

// This file contains a wrapper component around a password field with an added label.

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { generateTestId } from "~base/Components/Primitives/InputFunctions";
import Password from "~base/Components/Primitives/PasswordInput";
import { TitleContainer } from "~base/Components/Primitives/TitleContainer";
import { TitlePasswordProps } from "~base/Components/Primitives/TitlePassword";

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const TitlePassword: React.FunctionComponent<TitlePasswordProps> = (
    props: TitlePasswordProps
) => {
    const {
        testIdentifier,
        testIdentifierIndex,
        title,
        titleTextCode,
        titleSize,
        titleTextWrap,
        titleClassName,
        gridCols,
        style,
        className,
        margin,
        padding,
        defaultWidth,
        hidden,
        hiddenType,
        caption,
        captionTextCode,
        captionClassName,
        onCaptionClick,
        ...textInputProps
    } = props;

    const testIdValue = generateTestId(
        testIdentifier,
        testIdentifierIndex,
        null,
        titleTextCode
    );

    return (
        <TitleContainer
            testIdentifier={testIdentifier}
            testIdentifierIndex={testIdentifierIndex}
            title={title}
            titleTextCode={titleTextCode}
            titleSize={titleSize}
            titleTextWrap={titleTextWrap}
            titleClassName={titleClassName}
            gridCols={gridCols}
            padding={padding}
            margin={margin}
            style={style}
            className={className}
            defaultWidth={defaultWidth}
            hidden={hidden}
            hiddenType={hiddenType}
            caption={caption}
            captionTextCode={captionTextCode}
            captionClassName={captionClassName}
            onCaptionClick={onCaptionClick}
            enabled={props.enabled}
        >
            <Password {...textInputProps} testIdentifier={testIdValue} />
        </TitleContainer>
    );
};

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------
export default TitlePassword;
export { TitlePassword };
